(function() {
  'use strict';

  var ROOT_SELECTOR = '[data-free-gift-offer]';
  var GIFT_PROPERTY = '_v3_free_gift';

  function shopifyRoute(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return root + path.replace(/^\//, '');
  }

  function requestJSON(url, options) {
    return fetch(url, options || {})
      .then(function(response) {
        return response.json().catch(function() { return {}; }).then(function(body) {
          if (!response.ok) {
            var error = new Error(body.description || body.message || 'Cart request failed.');
            error.status = response.status;
            throw error;
          }
          return body;
        });
      });
  }

  function wait(ms) {
    return new Promise(function(resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function moneyText(value) {
    var container = document.createElement('span');
    container.innerHTML = value;
    return (container.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function requestJSONWith429Retry(url, options, delay) {
    return requestJSON(url, options).catch(function(error) {
      if (error.status !== 429) {
        throw error;
      }
      return wait(delay || 1500).then(function() {
        return requestJSON(url, options);
      });
    });
  }

  function FreeGiftOffer(root) {
    this.root = root;
    this.heading = root.querySelector('[data-free-gift-heading]');
    this.message = root.querySelector('[data-free-gift-message]');
    this.progress = root.querySelector('[data-free-gift-progress]');
    this.progressBar = root.querySelector('[data-free-gift-progress-bar]');
    this.error = root.querySelector('[data-free-gift-error]');
    this.cards = {};
    this.currentCart = null;
    this.qualifyingCount = 0;
    this.busy = false;
    this.reconciling = false;
    this.cartRequest = null;
    this.fetchTimer = null;
    this.reconcileTimer = null;

    var cardElements = root.querySelectorAll('[data-free-gift-card]');
    for (var i = 0; i < cardElements.length; i++) {
      var card = cardElements[i];
      var type = card.getAttribute('data-free-gift-card');
      var select = card.querySelector('[data-free-gift-select]');
      this.cards[type] = {
        type: type,
        element: card,
        productId: String(card.getAttribute('data-product-id')),
        threshold: parseInt(card.getAttribute('data-threshold'), 10),
        select: select,
        button: card.querySelector('[data-free-gift-add]'),
        status: card.querySelector('[data-free-gift-status]'),
        image: card.querySelector('[data-free-gift-image]'),
        originalPrice: card.querySelector('[data-free-gift-original-price]'),
        title: card.getAttribute('data-gift-title') || (type === 'socks' ? 'Nurses Compression Socks' : 'Nurse Badge Reels'),
        hasStock: !!(select && select.options.length)
      };
      this.updateVariantImage(this.cards[type]);
    }

    this.badgeThreshold = this.cards.badge ? this.cards.badge.threshold : null;
    this.socksThreshold = this.cards.socks ? this.cards.socks.threshold : null;
    var thresholds = Object.keys(this.cards).map(function(type) {
      return this.cards[type].threshold;
    }, this);
    this.maxThreshold = thresholds.length ? Math.max.apply(Math, thresholds) : 1;

    this.bindEvents();
    this.root.hidden = false;
    var self = this;
    window.setTimeout(function() {
      self.fetchCart();
    }, 500);
  }

  FreeGiftOffer.prototype.bindEvents = function() {
    var self = this;

    Object.keys(this.cards).forEach(function(type) {
      var card = self.cards[type];
      if (card.button) {
        card.button.addEventListener('click', function() {
          var giftLine = self.currentCart && self.getGiftLines(self.currentCart, type).filter(function(item) {
            return String(item.product_id) === card.productId;
          })[0];
          if (giftLine) {
            self.removeGiftLine(giftLine.key);
          } else {
            self.addGift(type);
          }
        });
      }
      if (card.select) {
        card.select.addEventListener('change', function() {
          self.updateVariantImage(card);
        });
      }
    });

    document.addEventListener('cart:updated', function(event) {
      var detail = event.detail || {};
      if (!detail.cart) {
        self.fetchCart();
        return;
      }
      if (detail.freeGiftOffer) {
        self.render(detail.cart);
        return;
      }
      self.render(detail.cart);
      self.scheduleCartReconcile(800);
    });

    document.addEventListener('ajaxProduct:added', function() {
      self.scheduleCartFetch(500);
    });
  };

  FreeGiftOffer.prototype.scheduleCartFetch = function(delay) {
    var self = this;
    if (this.fetchTimer) {
      window.clearTimeout(this.fetchTimer);
    }
    this.fetchTimer = window.setTimeout(function() {
      self.fetchTimer = null;
      self.fetchCart();
    }, delay || 500);
  };

  FreeGiftOffer.prototype.scheduleCartReconcile = function(delay) {
    var self = this;
    if (this.reconcileTimer) {
      window.clearTimeout(this.reconcileTimer);
    }
    this.reconcileTimer = window.setTimeout(function() {
      self.reconcileTimer = null;
      if (self.currentCart) {
        self.processCart(self.currentCart);
      }
    }, delay || 800);
  };

  FreeGiftOffer.prototype.fetchCart = function() {
    var self = this;
    if (this.cartRequest) {
      return this.cartRequest;
    }

    var cartUrl = window.theme && theme.routes && theme.routes.cart
      ? theme.routes.cart
      : shopifyRoute('cart.js');
    var url = cartUrl + (cartUrl.indexOf('?') === -1 ? '?' : '&') + 't=' + Date.now();
    var options = {
        credentials: 'same-origin',
        method: 'GET',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      };

    function loadCart(canRetry) {
      return requestJSON(url, options).catch(function(error) {
        if (error.status === 429 && canRetry) {
          return wait(1500).then(function() {
            return loadCart(false);
          });
        }
        throw error;
      });
    }

    this.cartRequest = loadCart(true).then(function(cart) {
      self.cartRequest = null;
      self.clearError();
      return self.processCart(cart);
    }, function(error) {
      self.cartRequest = null;
      self.showError(error.status === 429
        ? 'The cart is busy. Please wait a moment and try again.'
        : error.message);
      return null;
    });

    return this.cartRequest;
  };

  FreeGiftOffer.prototype.getGiftLineType = function(item) {
    if (!item || !item.properties) {
      return '';
    }
    return item.properties[GIFT_PROPERTY] || '';
  };

  FreeGiftOffer.prototype.getQualifyingCount = function(cart) {
    var self = this;
    var giftProductIds = Object.keys(this.cards).map(function(type) {
      return self.cards[type].productId;
    });

    return cart.items.reduce(function(total, item) {
      var isManagedGift = !!self.getGiftLineType(item);
      var isGiftProduct = giftProductIds.indexOf(String(item.product_id)) !== -1;
      return isManagedGift || isGiftProduct ? total : total + item.quantity;
    }, 0);
  };

  FreeGiftOffer.prototype.getGiftLines = function(cart, type) {
    var self = this;
    return cart.items.filter(function(item) {
      return self.getGiftLineType(item) === type;
    });
  };

  FreeGiftOffer.prototype.getCartCorrections = function(cart, qualifyingCount) {
    var self = this;
    var updates = {};

    cart.items.forEach(function(item) {
      var managedType = self.getGiftLineType(item);
      if (managedType && !self.cards[managedType]) {
        updates[item.key] = 0;
      }
    });

    Object.keys(this.cards).forEach(function(type) {
      var card = self.cards[type];
      var lines = self.getGiftLines(cart, type);
      var keptLine = false;

      lines.forEach(function(item) {
        var eligible = qualifyingCount >= card.threshold;
        var correctProduct = String(item.product_id) === card.productId;

        if (!eligible || !correctProduct || keptLine) {
          updates[item.key] = 0;
          return;
        }

        keptLine = true;
        if (item.quantity !== 1) {
          updates[item.key] = 1;
        }
      });
    });

    return updates;
  };

  FreeGiftOffer.prototype.processCart = function(cart) {
    var self = this;
    if (!cart || !Array.isArray(cart.items)) {
      return Promise.resolve();
    }

    this.currentCart = cart;
    this.qualifyingCount = this.getQualifyingCount(cart);
    var updates = this.getCartCorrections(cart, this.qualifyingCount);

    if (!Object.keys(updates).length || this.reconciling) {
      this.render(cart);
      return Promise.resolve(cart);
    }

    this.reconciling = true;
    this.setBusy(true);

    return requestJSONWith429Retry(shopifyRoute('cart/update.js'), {
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ updates: updates })
    }, 1500)
      .then(function(correctedCart) {
        self.reconciling = false;
        self.setBusy(false);
        self.render(correctedCart);
        self.notifyTheme();
        return correctedCart;
      })
      .catch(function(error) {
        self.reconciling = false;
        self.setBusy(false);
        self.showError(error.message);
      });
  };

  FreeGiftOffer.prototype.render = function(cart) {
    var self = this;
    this.currentCart = cart;
    this.qualifyingCount = this.getQualifyingCount(cart);
    var count = this.qualifyingCount;
    var cardTypes = Object.keys(this.cards);
    var unlockedTypes = cardTypes.filter(function(type) {
      return count >= self.cards[type].threshold;
    });
    var lockedCards = cardTypes.map(function(type) {
      return self.cards[type];
    }).filter(function(card) {
      return count < card.threshold;
    }).sort(function(a, b) {
      return a.threshold - b.threshold;
    });
    var nextLockedCard = lockedCards.length ? lockedCards[0] : null;
    var percent = Math.min(count / this.maxThreshold * 100, 100);

    this.progress.setAttribute('aria-valuemax', String(this.maxThreshold));
    this.progress.setAttribute('aria-valuenow', String(Math.min(count, this.maxThreshold)));
    this.progressBar.style.width = percent + '%';

    if (cardTypes.length && unlockedTypes.length === cardTypes.length) {
      this.heading.textContent = cardTypes.length > 1
        ? "You've unlocked all free gifts!"
        : "You've unlocked your free gift!";
      this.message.textContent = cardTypes.length > 1
        ? 'Choose your options and add each gift to your cart.'
        : 'Choose your option and add the gift to your cart.';
    } else if (unlockedTypes.length) {
      this.heading.textContent = "You've got a free gift!";
      var unlockedRemaining = Math.max(nextLockedCard.threshold - count, 0);
      this.message.textContent = 'Add ' + unlockedRemaining + ' more ' + (unlockedRemaining === 1 ? 'item' : 'items') + ' to unlock ' + nextLockedCard.title + '.';
    } else if (nextLockedCard) {
      this.heading.textContent = cardTypes.length > 1 ? 'Free gifts with your order' : 'Free gift with your order';
      var firstRemaining = Math.max(nextLockedCard.threshold - count, 0);
      this.message.textContent = 'Add ' + firstRemaining + ' ' + (firstRemaining === 1 ? 'item' : 'items') + ' to unlock ' + nextLockedCard.title + '.';
    }

    Object.keys(this.cards).forEach(function(type) {
      var card = self.cards[type];
      var unlocked = count >= card.threshold;
      var giftLines = self.getGiftLines(cart, type).filter(function(item) {
        return String(item.product_id) === card.productId;
      });
      var added = giftLines.length > 0;
      var remaining = Math.max(card.threshold - count, 0);

      card.element.classList.toggle('is-locked', !unlocked);
      card.element.classList.toggle('is-unlocked', unlocked);
      card.element.classList.toggle('is-added', added);

      if (added) {
        card.status.textContent = 'Added to your cart';
      } else if (unlocked) {
        card.status.textContent = 'Unlocked — choose your option';
      } else {
        card.status.textContent = 'Add ' + remaining + ' more ' + (remaining === 1 ? 'item' : 'items') + ' to unlock';
      }

      if (card.select) {
        card.select.disabled = self.busy || !unlocked || added || !card.hasStock;
      }

      if (card.button) {
        card.button.disabled = self.busy || (!added && (!unlocked || !card.hasStock));
        if (added) {
          card.button.textContent = self.busy ? 'Updating…' : 'Remove gift';
        } else if (!card.hasStock) {
          card.button.textContent = 'Out of stock';
        } else if (!unlocked) {
          card.button.textContent = 'Locked';
        } else if (self.busy) {
          card.button.textContent = 'Adding…';
        } else {
          card.button.textContent = 'Add gift';
        }
      }
    });
  };

  FreeGiftOffer.prototype.setBusy = function(busy) {
    this.busy = busy;
    this.root.classList.toggle('is-loading', busy);
    if (this.currentCart) {
      this.render(this.currentCart);
    }
  };

  FreeGiftOffer.prototype.mergeAddedItems = function(cart, response) {
    if (!cart || !Array.isArray(cart.items) || !response) {
      return null;
    }

    var addedItems = Array.isArray(response)
      ? response
      : (Array.isArray(response.items) ? response.items : [response]);
    if (!addedItems.length || !addedItems[0].key) {
      return null;
    }

    var items = cart.items.slice();
    var itemCount = typeof cart.item_count === 'number'
      ? cart.item_count
      : items.reduce(function(total, item) { return total + item.quantity; }, 0);

    addedItems.forEach(function(addedItem) {
      var existingIndex = -1;
      for (var i = 0; i < items.length; i++) {
        if (items[i].key === addedItem.key) {
          existingIndex = i;
          break;
        }
      }

      if (existingIndex === -1) {
        items.push(addedItem);
        itemCount += addedItem.quantity;
      } else {
        itemCount += addedItem.quantity - items[existingIndex].quantity;
        items[existingIndex] = addedItem;
      }
    });

    var nextCart = Object.assign({}, cart);
    nextCart.items = items;
    nextCart.item_count = itemCount;
    return nextCart;
  };

  FreeGiftOffer.prototype.addGift = function(type) {
    var self = this;
    var card = this.cards[type];
    if (!card || this.busy || this.qualifyingCount < card.threshold || !card.select) {
      return;
    }

    var variantId = parseInt(card.select.value, 10);
    if (!variantId) {
      this.showError('Please choose an available gift option.');
      return;
    }

    this.clearError();
    this.setBusy(true);

    requestJSON(window.theme && theme.routes && theme.routes.cartAdd ? theme.routes.cartAdd : shopifyRoute('cart/add.js'), {
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: (function() {
            var properties = {};
            properties[GIFT_PROPERTY] = type;
            return properties;
          })()
        }]
      })
    })
      .then(function(addResponse) {
        var updatedCart = self.mergeAddedItems(self.currentCart, addResponse);
        self.setBusy(false);
        self.clearError();

        if (updatedCart) {
          self.render(updatedCart);
          self.notifyTheme();
        } else {
          self.scheduleCartFetch(500);
        }
      })
      .catch(function(error) {
        self.setBusy(false);
        self.showError(error.message || 'Unable to add this gift. Please try again.');
      });
  };

  FreeGiftOffer.prototype.removeGiftLine = function(key) {
    var self = this;
    if (!key || this.busy) {
      return;
    }

    this.clearError();
    this.setBusy(true);

    return requestJSONWith429Retry(window.theme && theme.routes && theme.routes.cartChange
      ? theme.routes.cartChange
      : shopifyRoute('cart/change.js'), {
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: key, quantity: 0 })
    }, 1500)
      .then(function(updatedCart) {
        self.setBusy(false);
        self.clearError();
        self.render(updatedCart);
        self.notifyTheme();
        return updatedCart;
      })
      .catch(function(error) {
        self.setBusy(false);
        self.showError(error.message || 'Unable to remove this gift. Please try again.');
      });
  };

  FreeGiftOffer.prototype.updateVariantImage = function(card) {
    if (!card.select || card.select.selectedIndex < 0) {
      return;
    }
    var option = card.select.options[card.select.selectedIndex];
    var image = option.getAttribute('data-image');
    if (card.image && image) {
      card.image.src = image;
    }
    var originalPrice = option.getAttribute('data-original-price');
    if (card.originalPrice && originalPrice) {
      card.originalPrice.textContent = moneyText(originalPrice);
    }
  };

  FreeGiftOffer.prototype.notifyTheme = function() {
    document.dispatchEvent(new CustomEvent('cart:build'));
  };

  FreeGiftOffer.prototype.showError = function(message) {
    if (!this.error) {
      return;
    }
    this.error.textContent = message || 'Unable to update your cart. Please try again.';
    this.error.hidden = false;
  };

  FreeGiftOffer.prototype.clearError = function() {
    if (!this.error) {
      return;
    }
    this.error.textContent = '';
    this.error.hidden = true;
  };

  function init() {
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i].freeGiftOfferInstance) {
        roots[i].freeGiftOfferInstance = new FreeGiftOffer(roots[i]);
      }
    }
  }

  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-free-gift-remove-line-key]');
    if (!button) {
      return;
    }
    var form = button.closest('form');
    var root = form && form.querySelector(ROOT_SELECTOR);
    var offer = root && root.freeGiftOfferInstance;
    if (offer) {
      event.preventDefault();
      offer.removeGiftLine(button.getAttribute('data-free-gift-remove-line-key'));
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
